<template>
    <footer class="footer" :class="[{ 'health' : hpUrl == 'healthcenter'}, { 'enviro' : hpUrl == 'onecenter' }, { 'coop' : hpUrl == 'medicalcenter' }]">
        <div class="footer__bar">
            <div class="footer__center-list">
                <ul>
                    <li class="footer__center-item">
                        <a href="javascript:;" class="footer__center-link"><span class="name">주요 센터 이동하기</span><span class="icon"><img src="@/assets/resource/icon/menu-icon1.png" alt="이미지"></span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="javascript:;" class="footer__center-link"> <span class="name">창원파티마병원</span><span class="icon"><img src="@/assets/resource/icon/menu-icon2.png" alt="이미지"></span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://www.fatimahosp.co.kr/deptHp/1/healthcenter/main.do" class="footer__center-link" title="새창열림" target="_blank"> <span class="name">건강증진센터</span><span class="icon"><img src="@/assets/resource/icon/menu-icon3.png" alt="이미지"></span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://www.fatimahosp.co.kr/deptHp/3/medicalcenter/main.do" class="footer__center-link" title="새창열림" target="_blank"> <span class="name">진료협력센터</span><span class="icon"><img src="@/assets/resource/icon/menu-icon4.png" alt="이미지"></span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://www.fatimahosp.co.kr/deptHp/2/onecenter/main.do" class="footer__center-link" title="새창열림" target="_blank"> <span class="name">직업환경의학센터</span><span class="icon"><img src="@/assets/resource/icon/menu-icon5.png" alt="이미지"></span></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer__inner">
            <img src="@/assets/resource/icon/footer-logo.png" class="footer__logo" alt="창원파티마병원 로고">
            <div class="footer__menu">
                <ul class="footer__list">
                    <li class="footer__item">
                        <a href="/hospital/etc/privacy.do" class="footer__link blue" target="_blank" title="새 창 이동">개인정보처리방침</a>
                    </li>
                    <li class="footer__item">
                        <a href="/hospital/etc/email.do" class="footer__link" target="_blank" title="새 창 이동">이메일무단수집거부</a>
                    </li>
                    <li class="footer__item">
                        <a href="/hospital/etc/terms.do" class="footer__link" target="_blank" title="새 창 이동">이용약관</a>
                    </li>
                    <li class="footer__item">
                        <a href="/hospital/etc/nonpayment.do" class="footer__link" target="_blank" title="새 창 이동">비급여진료비용</a>
                    </li>
                    <li class="footer__item">
                        <a href="/hospital/etc/patientRight.do" class="footer__link" target="_blank" title="새 창 이동">환자권리존중 및 보호에 관한 선언문</a>
                    </li>
                </ul>
                <hr class="mo-line">
                <p class="footer__desc mt30">주소 : 경상남도 창원시 의창구 창이대로 45 창원파티마병원 (우 51394)</p>
                <p class="footer__desc">대표번호 : {{this.$parent.menuInfo.hpPhone}} <span class="line"></span> <br> 팩스 : {{this.$parent.menuInfo.hpEmail}}</p>
                <p class="footer__desc mt50">Copyrightⓒ Changwon Fatima Hospital.</p>
            </div>
            <div class="footer__site">
                <div class="footer__btn">
                        <div class="footer__site-wrap" :style="{ height: dynamicHeight }">
                            <ul class="footer__site-list">
                                <li class="footer__site-item">
                                    <p class="footer__site-tit">의료기관</p>
                                    <a href="https://www.fatimahosp.co.kr/" title="새창열림" target="_blank">창원파티마병원 </a>
                                    <a href="https://www.fatima.or.kr/main/main.do" title="새창열림" target="_blank">대구파티마병원</a>
                                </li>
                                <li class="footer__site-item">
                                    <p class="footer__site-tit">센터바로가기</p>
                                    <a href="/deptHp/1/healthcenter/main.do" title="새창열림" target="_blank">건강증진센터</a>
                                    <a href="/deptHp/2/onecenter/main.do" title="새창열림" target="_blank">직업환경의학센터</a>
                                    <a href="/deptHp/3/medicalcenter/main.do" title="새창열림" target="_blank">진료협력센터</a>
                                </li>
                                <li class="footer__site-item">
                                    <p class="footer__site-tit">관공서</p>
                                    <a href="https://www.benedictine.or.kr" title="새창열림" target="_blank">(재)대구포교베네딕도수녀회</a>
                                    <a href="http://cathms.kr" title="새창열림" target="_blank">천주교마산교구</a>
                                    <a href="https://www.mohw.go.kr/" title="새창열림" target="_blank">보건복지부</a>
                                    <a href="http://health.changwon.go.kr/" title="새창열림" target="_blank">창원시보건소</a>
                                    <a href="https://www.nhis.or.kr/nhis/index.do" title="새창열림" target="_blank">국민건강보험공단</a>
                                    <a href="https://www.hira.or.kr/main.do" title="새창열림" target="_blank">건강보험심사평가원</a>
                                    <a href="https://www.comwel.or.kr/comwel/landing.jsp" title="새창열림" target="_blank">근로복지공단</a>
                                </li>
                                <li class="footer__site-item">
                                    <p class="footer__site-tit">기타</p>
                                    <a href="https://www.kha.or.kr/main" title="새창열림" target="_blank">대한병원협회</a>
                                    <a href="https://www.kosqua.net/" title="새창열림" target="_blank">한국의료질향상학회</a>
                                    <a href="https://www.qi.or.kr/" title="새창열림" target="_blank">한국QI간호사회</a>
                                    <a href="https://www.koiha.or.kr/web/kr/index.do" title="새창열림" target="_blank">의료기관평가인증원</a>
                                    <a href="https://www.fatimahosp-irb.co.kr/" title="새창열림" target="_blank">IRB</a>
                                </li>
                            </ul>
                        </div>
                    <button type="button" class="footer__plusBtn" @click="toggleMenu()">관련사이트 <span class="plus"></span></button>
                </div>
            </div>
        </div>
        <a href="#" class="go-top" v-if="!mainPage"></a>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            isMenuOpen: false,
            dynamicHeight: '0',
            hpUrl: this.$route.params.hpUrl,
            mainPage: '',
            previousHeight: 0,
            mutationObserver: null,
        };  
    },
    methods: {
        checkSize() {
            const currentHeight = document.documentElement.scrollHeight;
            if (currentHeight !== this.previousHeight) {
                this.previousHeight = currentHeight;
                this.gsapGT()
            }
        },
        toggleMenu() {
            let footerSiteHeight = document.querySelector(".footer__site-list").offsetHeight;
            this.isMenuOpen = !this.isMenuOpen;
            if (this.isMenuOpen) {   
                this.dynamicHeight = `${footerSiteHeight}px`;
            } else {
                this.dynamicHeight = `0`;
            }
            setTimeout(() => {
                ScrollTrigger.refresh(); // 높이 변화 감지 후 ScrollTrigger 갱신
            }, 100); // 작은 지연 시간 추가
        },
        gsapGT(){
            setTimeout(() => {
                gsap.killTweensOf('.footer__center-list'); // 모든 항목의 애니메이션을 제거합니다.
                ScrollTrigger.getAll().forEach(trigger => trigger.kill()); // 모든 ScrollTrigger 인스턴스를 제거합니다.
                if(this.$route.path.indexOf('checkUpResultDetail.do') > -1){
                    gsap.set('.go-top', { 
                        opacity: 1, 
                        pointerEvents: 'all',
                        display: 'block' // 또는 'inline-block'이나 다른 적절한 값
                    });
                }else{
                    gsap.to('.go-top', {scrollTrigger: {trigger: '.container',start: 'top top',end: '+=100',toggleClass: { targets: '.go-top', className: 'show' },scrub: true},opacity: 1,pointerEvents: 'all'});                    
                }
                if (window.matchMedia("(max-width: 720px)").matches) {
                    gsap.to('.go-top', {scrollTrigger: {trigger: '.footer',start: 'top bottom-=10px',toggleClass: { targets: '.go-top', className: 'on' },scrub: true}});
                }else{
                    gsap.to('.go-top', {scrollTrigger: {trigger: '.footer',start: 'top bottom-=60px',toggleClass: { targets: '.go-top', className: 'on' },scrub: true}});
                }
            }, 1000);
        },
        removeGsapGT(){
            ScrollTrigger.getAll().forEach((el) => {
                const t = el.vars.trigger
                const s = el.vars.start
                if(typeof t == 'string' && t.indexOf('container') > -1){
                    el.kill()
                }
                if(typeof s == 'string' && s.indexOf('top bottom-=10px') > -1 || s.indexOf('top bottom-=60px') > -1){
                    el.kill()
                }
            })
        },
    },
    watch: {
        $route(to, from){
            if(to.path != from.path){
                this.removeGsapGT();
                this.gsapGT();
            }
        }
    },
    mounted() {
        this.previousHeight = document.documentElement.scrollHeight;
        this.mutationObserver = new MutationObserver(this.checkSize);
        this.mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });

        setTimeout(() => {
            gsap.to('.footer__center-list', { scrollTrigger: { trigger: '.information', start: '30% center', end: '-100%', scrub: true }, bottom: '0' });
            gsap.to('.footer__center-list', { scrollTrigger: { trigger: '.footer', start: 'top bottom', scrub: true, toggleClass: { targets: '.footer__center-list', className: 'on' } } });
        }, 500);

        this.removeGsapGT();
        this.gsapGT();
      

        if (this.$route.path.indexOf('/main.do') > -1) {
            this.mainPage = true;
        } else {
            this.mainPage = false;
        }
    },
    beforeDestroy() {
        gsap.killTweensOf('.footer__center-list'); // 모든 항목의 애니메이션을 제거합니다.
        ScrollTrigger.getAll().forEach(trigger => trigger.kill()); // 모든 ScrollTrigger 인스턴스를 제거합니다.
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    },
}
</script>
